/**
 * Edit Scheduled Task Page
 */

import { useRoute, useSearch } from 'wouter';
import { ScheduledTaskForm } from '../../../components/scheduled-tasks/ScheduledTaskForm';
import { PageWrapper } from '@/components/layout/PageWrapper';

export default function EditScheduledTaskPage() {
  const [, params] = useRoute('/scheduled-tasks/:id/edit');
  const searchParams = new URLSearchParams(useSearch());
  const taskId = params?.id;
  const returnPath = searchParams.get('returnPath') || '/scheduled-tasks';

  if (!taskId) {
    return (
      <PageWrapper padding="default">
        <p className="text-red-500">Task ID is required</p>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper padding="default">
      <ScheduledTaskForm mode="edit" taskId={taskId} returnPath={returnPath} />
    </PageWrapper>
  );
}